import React, { useState } from 'react'
import { Email } from '@smastrom/react-email-autocomplete'
import { emailRegex } from '@/lib/regex'
import { TextItemInterface } from '@/types/newTypes'
import clsx from 'clsx'
import SecurityAndPrivacy from './screens/SecurityAndPrivacy'
import TryButton from './screens/TryButton'
import { useNavigate } from 'react-router-dom'
import { trackEmail, trackLead } from '@/helpers/facebookPixelEvents'

export const EmailForm = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState<string>('')
  const [isValid, setIsValid] = useState<boolean>(true)

  const handleEmailChange = (value: string) => {
    setEmail(value)
    setIsValid(emailRegex.test(value))
  }

  const handleAddEndingByButton = (value: string) => {
    const newValue = email.split('@')[0] + value
    setEmail(newValue)
    setIsValid(emailRegex.test(newValue))
  }

  const baseList = [
    'gmail.com',
    'hotmail.com',
    'yahoo.com',
    'outlook.com',
    'aol.com',
    'icloud.com',
    'live.com',
    'msn.com',
    'me.com',
    'mac.com',
    'googlemail.com',
    'facebook.com',
    'verizon.net',
    'rediffmail.com',
    'zohomail.com',
    'zoho.com',
    'mail.com',
    'google.com',
    'comcast.com',
    'hotmail.co.uk',
    'yahoo.co.uk',
    'att.net',
    'gmz.com',
  ]

  const buttons: TextItemInterface[] = [
    {
      text: '@gmail.com',
    },
    {
      text: '@yahoo.com',
    },
    {
      text: '@hotmail.com',
    },
  ]

  const handleSubmit = () => {
    localStorage.setItem('userEmail', email)
    trackLead()
    trackEmail('Mail_completed', email)
    navigate('/paywall')
  }

  return (
    <section className="py-8 sm:px-4">
      <div className="max-w-[305px] mx-auto mb-6 flex gap-2 rounded-xs py-2 px-4 bg-orangeToYellowGradientDark dark:bg-orangeToYellowGradient text-SM2 font-semibold tracking-[0.5px] uppercase">
        <svg viewBox="0 0 16 16" width={16}>
          <use href="/svg/sprite.svg#star"></use>
        </svg>
        <span>5+ million users have trusted us</span>
      </div>
      <h2 className="mb-2 text-center text-XL font-bold">
        Enter your email to start freeing up space!
      </h2>
      <h3 className="mb-6 text-white/70 text-center text-logo">
        We’ll create an account for you to manage
        <br />
        your cleanup process
      </h3>

      <div className="email-input-container" data-valid={isValid ? 'true' : 'false'}>
        <Email
          baseList={baseList}
          onChange={handleEmailChange}
          value={email}
          placeholder="Email"
          refineList={baseList}
        />
      </div>
      <div className="flex gap-2.5 mb-10">
        {buttons.map((item, index) => (
          <button
            key={index}
            type="button"
            onClick={() => handleAddEndingByButton(item.text)}
            disabled={email.length === 0}
            className={clsx(
              'h-[34px] py-2 px-2.5 text-SM2 font-normal rounded-2xl border text-graySecondary dark:border-graySecondary disabled:cursor-default',
            )}
          >
            {item.text}
          </button>
        ))}
      </div>
      <div className="mb-6">
        <TryButton
          text="Continue"
          disabled={!isValid || email.length === 0}
          onClick={() => handleSubmit()}
        />
      </div>
      <SecurityAndPrivacy secondary />
    </section>
  )
}
